<template>
  <div>
    <v-row>
      <v-col>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                small elevation="0" fab color="primary"
                @click="sendAssignmentDialog = true"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span class="tooltip-text">ارسال فایل به هنرجو</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row class="assignments-container">
      <v-col cols="12" v-for="assignment in assignments" :key="'assigment'+assignment.id">
        <div class="assignment-container">
          <v-row>
            <v-col cols="6">{{ assignment.title }}</v-col>
            <v-col cols="6" class="text-left" v-if="assignment.item_file_title">
              فایل درس: {{ assignment.item_file_title }}
            </v-col>
            <v-col
                v-if="assignment.sent_by === 'admin' || assignment.sent_by === 'instructor'"
                class="text-left">
              <v-icon @click="removeFileInitialize(assignment)" style="cursor: pointer" color="error">mdi-close</v-icon>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="file-show-container text-center">
                <img v-if="assignment.attachment_type === 'image'"
                     :src="assignment.url" class="image-lesson"
                     :alt="assignment.title" width="250vh" height="200vh">
                <audio v-else-if="assignment.attachment_type === 'audio'"
                       :src="assignment.url" controls style="width: 100%"></audio>
                <video-player :options="videoOptions" source="onlineClassItem"
                              v-else-if="assignment.attachment_type === 'video' && selectedVideoForShow.id === assignment.id">
                </video-player>
                <div v-else-if="assignment.attachment_type === 'video' && selectedVideoForShow.id !== assignment.id"
                     @click="openVideo(assignment)" class="text-center">
                  <img width="200vh" height="200vh" src="@/assets/play-video.png" alt="play video">
                </div>
                <v-btn v-else style="letter-spacing: normal" width="100%"
                       color="primary"
                       @click="goTo(assignment.url)">مشاهده
                </v-btn>
              </div>
            </v-col>
            <v-col class="text-left" cols="6" v-if="assignment.sent_by === 'admin'">فرستاده شده توسط مدیر</v-col>
            <v-col class="text-left" cols="6" v-if="assignment.sent_by === 'student'">فرستاده شده توسط هنرجو</v-col>
            <v-col class="text-left" cols="6" v-if="assignment.sent_by === 'instructor'">فرستاده شده توسط مربی</v-col>
            <v-col cols="6" class="text-right"> در
              {{ assignment.created_at_fa }}
            </v-col>
            <v-col cols="12" class="ma-0 pa-0">
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="sendAssignmentDialog" max-width="50vw">
      <v-card class="ma-0">
        <v-row class="px-16 ma-0">
          <v-col cols="6">
            <v-text-field
                color="black"
                label="عنوان"
                v-model="file.title">
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select
                label="نوع فایل را مشخص کنید"
                :items="attachmentTypes"
                v-model="file.attachment_type"
                item-value="value"
                item-text="text"
                color="black"
            >
            </v-select>
          </v-col>
          <v-col cols="12">
            <v-text-field label="فایل"
                          disabled
                          color="black"
                          v-model="file.url">
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <drag-and-drop module="assignment" ref="image-uploader" @closeUploadFileDialog="fileDialog = false"
                           @changeFile="file.url = $event"></drag-and-drop>
          </v-col>
          <v-col cols="12">
            <v-btn block style="letter-spacing: normal" color="success" @click="send()">ارسال</v-btn>
          </v-col>
        </v-row>
      </v-card>

    </v-dialog>
    <v-dialog width="50%" v-model="deleteFileDialog">
      <v-card>
        <v-card-actions>
          <v-icon color="error" @click="deleteFileDialog = false">mdi-close</v-icon>
        </v-card-actions>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              آیا از پاک کردن این فایل اطمینان دارید؟
            </v-col>
            <v-col cols="3"></v-col>
            <v-col cols="3">
              <v-btn color="warning" @click="removeFile()">بله مطمعنم</v-btn>
            </v-col>
            <v-col cols="3">
              <v-btn color="success" @click="deleteFileDialog = false">خیر منصرف شدم</v-btn>
            </v-col>
            <v-col cols="3"></v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop";
import VideoPlayer from "@/components/Player/VideoPlayer";

export default {
  name: "LessonAssignment",
  components: {DragAndDrop, VideoPlayer},
  props: ['onlineClassId', 'lessonId', 'studentId'],
  data() {
    return {
      selectedFileId: null,
      deleteFileDialog: false,
      sendAssignmentDialog: false,
      fileDialog: false,
      assignments: [],
      file: {
        title: null,
        url: null,
        attachment_type: null,
      },
      attachmentTypes: [
        {value: 'audio', text: 'فایل صوتی'},
        {value: 'video', text: 'ویدیو'},
        {value: 'pdf', text: 'پی دی اف'},
        {value: 'image', text: 'تصویر'},
      ],
      selectedVideoForShow: {
        id: null
      },
      videoOptions: {
        autoplay: true,
        playbackRates: [0.5, 1, 1.5, 2, 4, 8],
        controls: true,
        liveui: true,
        responsive: true,
        sources: [
          {
            src: '',
            type: "application/vnd.apple.mpegurl"
          }
        ],
      },
    }
  },
  methods: {
    goTo(path) {
      window.open(path)
    },
    openVideo(assignment) {
      this.selectedVideoForShow = assignment
      this.videoOptions.sources[0].src = assignment.url
    },
    getAssignments() {
      window.axios.get('admin/student/assignment/index/' + this.onlineClassId + '/' + this.lessonId + '/' + this.studentId).then((res) => {
        this.assignments = res.data.data
      })
    },
    send() {
      window.axios.post('admin/student/assignment/create/' + this.onlineClassId + '/' + this.lessonId + '/' + this.studentId, this.file).then(() => {
        this.getAssignments()
        this.openSnackbar('فایل شما با موفقیت ارسال شد.', 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    removeFileInitialize(assignment) {
      this.deleteFileDialog = true
      this.selectedFileId = assignment.id
    },
    removeFile() {
      window.axios.delete('admin/student/assignment/delete/' + this.selectedFileId).then(() => {
        this.openSnackbar('فایل ارسالی شما با موفقیت حذف شد.', 'success')
      }).finally(() => {
        this.getAssignments()
        this.deleteFileDialog = false
      })
    }
  },
  mounted() {
    this.getAssignments()
  }
}
</script>

<style scoped>
.assignments-container {
  height: 70vh !important;
  overflow-y: scroll !important;
}

.assignment-container {
  height: 32vh !important;
}

.file-show-container {
  aspect-ratio: 1 !important;
  height: 20vh !important;
  width: 100%;
}
</style>
